<template>
	<div class="remain_continer">
      <span v-for="(item, index) in hourTicketsArr" 
            :key="index" 
            class="remain_txt">
            {{item}}
            <!-- <count-to :startVal="3" :endVal="item" :duration="2000"></count-to> -->
      </span>
    </div>
</template>

<script>
  import CountTo from 'vue-count-to';
	export default {
    components: {
      CountTo
    },
		data() {
      return {
        
      }
    },
    computed: {
      hourTicketsArr() {
        return this.$store.getters['ticketStore/getHourTicketsArr'];
      }
    },
    
    methods: {
      
    },
    
    created() {
      // console.log('门票组件初始化');
      this.$store.dispatch('ticketStore/initializeTicketSystem');
    },
    destroyed(){
      this.$store.commit('ticketStore/cleanupTimers');
    }
	}
</script>

